$(document).ready(function () {

  var srCH = $('.sr-collection-nav__item.js-collection-filter-nav-toggle.is-active').text().trim().replace('🌴', 'i').toUpperCase();
  $('h1.sr-collection__heading').text('Shop' + ' ' + srCH);

  $('.sfs-progress__bar-wrapper, .sfs-stats__content-wrapper').attr('aria-live', 'polite');

  $('.hangover-shop-two-up-column-right img:not(.hangover-shop-hero-heading-bg)').attr('alt', 'Vitacoco Coconut Water Replenish, Enjoy, Recover and Hydrate');

});

$(window).on('load', function () {

  function replaceTag(selector, newTagName) {
    var elements = document.querySelectorAll(selector);
    elements.forEach(function(element) {
        var newElement = document.createElement(newTagName);
        Array.from(element.attributes).forEach(function(attr) {
            newElement.setAttribute(attr.name, attr.value);
        });
        newElement.innerHTML = element.innerHTML;
        element.parentNode.replaceChild(newElement, element);
    });
  }

  $('a[target="_blank"]').each(function () {
    var tbtxt = $(this).text();
    $(this).attr('aria-label', tbtxt + ' Opens in a new tab');
  });

  $('span.icon img, .slick-track img, .hangover-subscription-quotes-slide-img img').attr('alt', '');

  $(document).on('keydown', '.cc-settings, .pd-cp-ui-close, .pd-cp-btn, .pd-cp-bold-messaging, .pd-cp-preferences-switch, .hblp-buybox__container [data-product-id], .hangover-subscription-build-product-label, .variant-radios__label, .hangover-subscription-faq-heading[role="button"], .hangover-subscription-build-buy-box-qty .pdp-qty-trigger, a.hangover-subscription-build-buy-box-submit-product', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      $(this).click();
    }
  });

  $(document).on('keydown', '.cc-allow', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      Pandectes.fn.savePreferences()
    }
  });
  $(document).on('keydown', '.cc-deny', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      Pandectes.fn.revokeConsent({
        preventOpen: false,
      });
    }
  });
  $(document).on('keydown', '.cc-dismiss', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      Pandectes.fn.hideBanner()
    }
  });

  $(document).on('click keypress', '.cc-settings', function (e) {
    if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
      $('.cc-settings, #pd-cp-preferences').attr({ 'tabindex': '0' }).focus();
      $('#pd-cp-preferences .pd-cp-ui').prepend('<div class="focus-trap" id="first-focus" tabindex="0" aria-hidden="true">').append('<div class="focus-trap" id="last-focus" tabindex="0" aria-hidden="true">').focus();
      $('#pd-cp-preferences .pd-cp-ui').find('#last-focus').focus(function (event) {
        $('#pd-cp-preferences .pd-cp-ui').find('#first-focus').focus();
        event.preventDefault();
      });
    }
  });

  $(document).on('click keypress', '.pd-cp-ui-close', function (e) {
    if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
      $('#pd-cp-preferences').find('.focus-trap').remove();
      $('a.cc-settings').focus();
    }
  });

  $(document).on('PandectesEvent_OnShow', function () {
    $('.cc-banner-logo').attr('alt', '');
    $('#cookie-consent-dialogBox').attr({ 'role': 'alertdialog', 'tabindex': '0' }).focus();
    $('#pd-cp-preferences').attr({ 'role': 'dialog', 'aria-modal': 'true', 'aria-labelledby': 'pd-cp-ui-title' });
    $('.cc-message a.cc-link').removeAttr('role tabindex').attr('aria-label', 'Privacy Policy - Open in a new tab');
    $('.pd-cp-btn, .pd-cp-ui-close').attr({ 'role': 'button', 'tabindex': '0' });
    $('.pd-cp-bold-messaging, .pd-cp-preferences-switch').attr('tabindex', '0');
    $('.pd-cp-purpose-actions input[type="checkbox"').attr('role', 'switch');
    $('.pd-cp-ui-title').attr('id', 'pd-cp-ui-title');
    $('.cc-settings').attr({ 'role': 'button', 'aria-label': 'settings cookies preferences' });
    $('.cc-allow').attr('aria-label', 'Accept cookies');
    $('.cc-deny').attr('aria-label', 'Decline cookies');
    $('.cc-dismiss').attr('aria-label', 'dismiss cookie message ok');
    $('.pd-cookie-banner-window').prepend('<div class="focus-trap" id="first-focus" tabindex="0" aria-hidden="true">').append('<div class="focus-trap" id="last-focus" tabindex="0" aria-hidden="true">').focus();
    $('.pd-cookie-banner-window').find('#last-focus').focus(function (event) {
      $('.pd-cookie-banner-window').find('#first-focus').focus();
      event.preventDefault();
    });
  });

  setTimeout(() => {
    $(document).trigger('PandectesEvent_OnShow');
  }, 500);

  $('.navbar-item .site-nav__link svg').parent().attr({ 'aria-haspopup': 'true', 'aria-expanded': 'false' });
  $('.navbar-item .site-nav__link svg').parent().parent().addClass('has-submenu');
  $('.mega-menu-section').each(function () {
    var dataParentLink = $(this).find('.mega-menu').attr('data-parent-link');
    $(this).appendTo('li[data-navlink-handle="' + dataParentLink + '"]');
    $(this).find('.mega-menu').removeClass('is-active');
    $(this).find('button.js-mega-menu-sub-toggle').attr({ 'aria-haspopup': 'true', 'aria-expanded': 'false' });
    $(this).find('.js-mega-menu-sub-toggle.is-active').attr('aria-expanded', 'true');
    $(this).find('.yotpo-bottomline.star-clickable').attr('tabindex', '-1');
    $(this).css('display', 'none');
  });
  $('.has-submenu a.site-nav__link').on('click keypress', function (e) {
    if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
      $(this).attr('aria-expanded', 'true');
      $(this).next('.mega-menu-section').css('display', 'block');
      $(this).next('.mega-menu-section').find('.mega-menu').addClass('is-active');
      $(this).parent().siblings('.has-submenu').find('a.site-nav__link').attr('aria-expanded', 'false');
      $(this).parent().siblings('.has-submenu').find('.mega-menu-section').css('display', 'none');
      $(this).parent().siblings('.has-submenu').find('.mega-menu').removeClass('is-active');
      $(document).on('keyup', '.shopify-section-group-header-group', function (closeNav) {
        if (closeNav.key === 'Escape') {
          $('.has-submenu').removeClass('is-mega-menu-open');
          $('.has-submenu').find('a.site-nav__link').attr('aria-expanded', 'false');
          $('.has-submenu').find('.mega-menu-section').css('display', 'none');
          $('.has-submenu').find('.mega-menu').removeClass('is-active');
        }
      });
      $('button.js-mega-menu-sub-toggle').on('keydown', function (e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
          $(this).attr({ 'aria-expanded': 'true', 'aria-selected': 'true' });
          $(this).parent().siblings().find('button.js-mega-menu-sub-toggle').attr({ 'aria-expanded': 'false', 'aria-selected': 'false' });
        }
      });
      $('.js-mega-menu-sub-toggle').keydown(function (e) {
        if (e.which === 9 && !e.shiftKey) {
          e.preventDefault();
          var currentValue = $(this).attr('data-value');
          var $nextColumn = $('.js-mega-menu-column[data-value="' + currentValue + '"]');
          $nextColumn.find('li:first-child a.mega-menu__image-wrap').focus();
        }
      });
      $('.js-mega-menu-column li:last-child a.mega-menu__image-wrap').keydown(function (e) {
        if (e.which === 9 && !e.shiftKey) {
          e.preventDefault();
          var currentValue = $(this).closest('.js-mega-menu-column').attr('data-value');
          var $nextButton = $('.js-mega-menu-sub-toggle[data-value="' + currentValue + '"]');
          var $nextSiblingButton = $nextButton.parent().next().find('.js-mega-menu-sub-toggle');
          if ($nextSiblingButton.length) {
            $nextSiblingButton.focus();
          } else {
            $nextButton.closest('.mega-menu__content').find('a.mega-menu__btn').focus();
          }
        }
      });
      $('.mega-menu__content a.mega-menu__btn').keydown(function (e) {
        if (e.which === 9 && !e.shiftKey) {
          e.preventDefault();
          $(this).closest('.has-submenu').next().find('a.site-nav__link').focus();
        }
      });
    }
  });
  $('.site-header__main-nav').on('mouseenter', function () {
    $('.has-submenu a.site-nav__link').attr('aria-expanded', 'false');
    $('.has-submenu .mega-menu-section').removeAttr('style');
  });
  $('.mega-menu').on('mouseleave', function () {
    setTimeout(() => {
      $(this).removeClass('is-active');
      $(this).closest('.has-submenu').removeClass('is-mega-menu-open');
      $('body').removeClass('is-show-mega-menu');
    }, 100);
  });

  $('button.yotpo-smsbump-close-button').on('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      $('#pandectes-banner').focus();
    }
  });
  $('.yotpo-smsbump-floating-button button').attr('aria-label', 'Sign up to get 15% off');

  var $siteNav = $('.site-header__secondary-links ul.site-nav');
  $('.site-header__utility-nav:not(.path-pages-hangover-subscription-plan .site-header__utility-nav) details-modal.header__search').appendTo($siteNav).wrap('<li></li>');
  $('.site-header__utility-nav:not(.path-pages-hangover-subscription-plan .site-header__utility-nav) a.header__link.header__link-account.action-area__link').appendTo($siteNav).wrap('<li></li>');
  $('.site-header__utility-nav:not(.path-pages-hangover-subscription-plan .site-header__utility-nav) div.header-cart.action-area__link').appendTo($siteNav).wrap('<li></li>');
  $('button.sr-search-modal__close-button, button.sr-search__button, .hp-value-prop__item, .press-quotes-page, .hblp-buybox__container [data-product-id], .pdp-qty-minus, .pdp-qty-plus, a[class*="manage_subscriptions_btn"]').attr('tabindex', '0');
  $('.sr-search-modal__content').find('button.sr-search-modal__close-button').focus(function (e) {
    $(this).find('button.sr-search__button').focus();
    e.preventDefault();
  });
  $('.sr-search-modal .sr-search-modal__close-button').appendTo('.sr-search-modal form.sr-search-modal__form');
  $('input.sr-search-modal__input').on('focusout', function () {
    $('.sr-search-modal__content, .sr-search-modal__content .predictive-search--header, .sr-search-modal__content a.predictive-search__item').removeAttr('tabindex');
  });

/**
 * These commented lines break cart functionality. Do not do this.
 */
  $('.header-cart[data-ajax-cart-trigger], button#addToCart, button#AddToCart, button.hp-product-card__btn').on('click keypress', function (e) {
    if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
      $(this).addClass('focus-back');
    }
  });

  $('.press-quotes-page img[src*="forbes"]').attr('alt', 'Forbes Logo');
  $('.press-quotes-page img[src*="bevnet"]').attr('alt', 'Bevnet Logo');
  $('.press-quotes-page img[src*="entertainment"]').attr('alt', 'Entertainment Logo');
  $('.press-quotes-page img[src*="Yahoo"]').attr('alt', 'Yahoo Logo');

  $('.yotpo-widget-campaign-widget .yotpo-widget-campaign-widget-icon-container img, .yotpo-vip-tiers-card-container .yotpo-vip-tier-icon-wrapper img').attr('alt', '');

  $('#page-vita-coco .hp-hero .hp-hero__icon-animated img').attr('alt', 'Made With Coconuts');

  $('ul.hp-products__grid').next().prependTo('.hp-products__grid-wrap');
  $('.hp-products__prev').attr('aria-label', 'Previous Slide');
  $('.hp-products__next').attr('aria-label', 'Next Slide');

  $('.press-quotes-page, button.js-mega-menu-sub-toggle').each(function () {
    if ($(this).hasClass('is-active')) {
      $(this).attr('aria-selected', 'true');
    } else {
      $(this).attr('aria-selected', 'false');
    }
  });
  $(document).on('focusin', '.is-desk .press-quotes-page', function () {
    $('.press-quotes').slick('slickGoTo', parseInt($(this).attr('data-index')));
    $(this).siblings().removeClass('is-active').attr('aria-selected', 'false');
    $(this).addClass('is-active').attr('aria-selected', 'true');;
  });

  $('.hblp-buybox__product-btn, .hblp-buybox__gift-btn').on('click', function () {
    var isSelected = $(this).attr('aria-selected');
    var isPressed = $(this).attr('aria-pressed');
    if (isSelected === 'true') {
      $(this).attr('aria-pressed', 'true');
      $(this).siblings().attr('aria-pressed', 'false');
    } else {
      $(this).removeAttr('aria-pressed');
      $(this).siblings().removeAttr('aria-pressed');
    }
  });

  $('a.footer-social-icon').each(function () {
    var href = $(this).attr('href');
    if (href.includes('linkedin')) {
      $(this).attr('aria-label', 'Vitacoco Social Media - Linkedin');
    }
    if (href.includes('facebook')) {
      $(this).attr('aria-label', 'Vitacoco Social Media - Facebook');
    }
    if (href.includes('twitter')) {
      $(this).attr('aria-label', 'Vitacoco Social Media - Twitter');
    }
    if (href.includes('instagram')) {
      $(this).attr('aria-label', 'Vitacoco Social Media - Instagram');
    }
    if (href.includes('snapchat')) {
      $(this).attr('aria-label', 'Vitacoco Social Media - Snapchat');
    }
    if (href.includes('tiktok')) {
      $(this).attr('aria-label', 'Vitacoco Social Media - Tiktok');
    }
  });

  $('#ContactFooter-email').before('<label class="input-group__label" for="ContactFooter-email">Email Address</label>');
  $('.input-group__field').on('focusin', function () {
    $('.input-group__label').attr({ 'style': 'opacity: 1; visibility: visible; transform: translateY(-27px)' });
  }).on('focusout', function () {
    $('.input-group__label').removeAttr('style');
  });

  $('.create-customer-wrap h2.thinner-title, #RecoverPasswordForm h2.thinner-title').attr('aria-level', '1');
  $('.account-password-container button.account-password-button').attr('aria-label', 'Show Password');
  $('.account-password-input').prependTo('.account-password-container');
  $('.errors li').attr('role', 'alert');
  $('input[type="email"]').attr('autocomplete', 'email');
  // Issue 36
  // $('[id="pandectes-rules"]').each(function() {
  //     var uniqueString = '_' + Math.random().toString(36).substr(2, 9);
  //     $(this).attr('id', 'pandectes-rules' + uniqueString);
  // });

  var fields = [
    {
      name: '[id="first-name"], [id="ContactFormFirstName"]',
      message: "Please enter your first name.",
      autocomplete: "given-name",
    },
    {
      name: '[id="ContactFormLastName"]',
      message: "Please enter your last name.",
      autocomplete: "family-name",
    },
    {
      name: '[id="CustomerEmail"], [name="email"], [id="yotpo-smsbump-email-input__field"]',
      message: "Please enter a valid email address.",
      autocomplete: "email",
    },
    {
      name: '[id="ContactFormPhone"]',
      message: "Please enter your phone number.",
      autocomplete: "tel-local",
    },
    {
      name: '[id="ContactFormMessage"]',
      message: 'Please tell us more.',
      autocomplete: 'off'
    }
  ];

  var handleInvalid = function (event, message) {
    if (event.target.validity.valueMissing)
      event.target.setCustomValidity(message);
  };

  fields.forEach(function (field) {
    var elements = document.querySelectorAll(field.name);
    elements.forEach(function (element) {
      element.addEventListener("invalid", function (event) {
        handleInvalid(event, field.message);
      });
      element.addEventListener("change", function () {
        element.setCustomValidity("");
      });
      if (field.autocomplete) {
        element.setAttribute("autocomplete", field.autocomplete);
      }
    });
  });

  $('img.yotpo-widget-campaign-widget-custom-icon').attr('alt', '');
  $('div.yotpo-title, div.contact-page__title, .yotpo-header-element .y-label.yotpo-user-name, .index-section:first .page-header .page-heading, #pdp-section-ingredients .quote-text.large, .hangover-subscription-faqs-heading, .acct-login-ctas-create div.acct-label, #hangover-subscription-quotes [class^="hangover-subscription-quotes-slider-intro"], .hangover-subscription-build-heading').attr('role', 'heading');
  $('#page-rewards .yotpo-widget-hero-section .yotpo-title, .contact-page__title.h1, .index-section:first .page-header .page-heading').attr('aria-level', '1');

  $('button[onclick="Pandectes.fn.revokeConsent()"]').on('keydown', function (e) {
    if (e.key === 'Enter' || e.keyCode === 13) {
      $('a.cc-link').focus();
    }
  });

  $('.yotpo-label .yotpo-logo-link-new').attr('aria-label', 'Reviews Powered by Yotpo, Click to navigate to Yotpo homepage link - Open in new tab');
  $('.yotpo-review .yotpo-icon-profile, span.sr-collection__results-count').attr('aria-hidden', 'true');
  $('#page-reviews #yotpo_testimonials_btn, .tlp-slider__slide').removeAttr('tabindex');
  $('.yotpo-header-element .label-with-tooltip').removeAttr('aria-level');
  $('.yotpo-header .yotpo-icon-profile, .yotpo-header-element .y-label.yotpo-user-title, .hp-products .hp-product-card, .sr-collection .hp-product-card, .yotpo-reviews .yotpo-pager, .yotpo-reviews .yotpo-pager .yotpo-page-element.goTo').removeAttr('role');
  $('#pdp-section-ingredients .quote-text.large, #shopify-section-why-coconuts h1.huge-title, #shopify-section-why-coconuts-2up-slider .why-coconuts-2up-slider-info h1, #shopify-section-hp-products h2.hp-products__heading, #shopify-section-why-coconuts-instagram h3, .hangover-subscription-faqs-heading.h2, .acct-login-ctas-create div.acct-label, #hangover-subscription-quotes [class^="hangover-subscription-quotes-slider-intro"], .hangover-subscription-build-heading, .why-coconuts-hero-additional-info h3.white').attr('aria-level', '2');
  $('.yotpo-page-element.yotpo_previous, .yotpo-page-element.yotpo_next').attr('href', '#');

  $('#ef-faqs-plus-app-content').attr({ 'aria-live': 'polite', 'aria-label': 'FAQ Search Results' });
  $('.faq-page-filter-display').attr({ 'tabindex': '0', 'role': 'combobox', 'aria-label': 'Filter by', 'aria-expanded': 'false', 'aria-controls': 'filterby-controls' });
  $('.faq-page-filter-dropdown-options').attr({ 'id': 'filterby-controls', 'role': 'listbox', 'aria-hidden': 'true' });

  $('.faq-page-filter-display').on('keydown', function (e) {
    if (e.key === 'Enter' && e.keyCode === 13) {
      $(this).click();
      $(this).attr('aria-expanded', 'true');
      $('.faq-page-filter-dropdown-display, .faq-page-filter-dropdown-options > div').attr('tabindex', '0');
      $('.faq-page-filter-dropdown-options').attr('aria-hidden', 'false');
      $('.faq-page-filter-dropdown-options > div').attr('role', 'option');
    }
  });
  $('.faq-page-filter-dropdown').on('click', function () {
    $('.faq-page-filter-display').attr('aria-expanded', 'false');
    $('.faq-page-filter-dropdown-display, .faq-page-filter-dropdown-options > div').removeAttr('tabindex');
    $('.faq-page-filter-dropdown-options').attr('aria-hidden', 'true');
  });

  $('<span class="sr-only"> filter results displayed</span>').appendTo('.js-collection-filter-result-count:not(.sr-collection__results-count)');

  $('.kaltura-player-container[tabindex="-1"]').find('[tabindex="0"]').attr('tabindex', '-1');

  $('p.pick-flavor, .hblp-buybox__product-btns').wrapAll('<fieldset>');
  $('p.pick-gift, .hblp-buybox__gift-btns').wrapAll('<fieldset>');
  $('fieldset p.pick-flavor, fieldset p.pick-gift').wrap('<legend>');
  $('.hblp-buybox__container [data-selected], .hangover-subscription-build-product-label, a.btn-with-arrow, a[class*="manage_subscriptions_btn"]').attr('role', 'button');
  $('[data-selected="false"], .hangover-subscription-build-product-label[tabindex="1"], .sr-collection-nav__item.js-collection-filter-nav-toggle').attr('aria-selected', 'false');
  $('[data-selected="true"], .hangover-subscription-build-product-label[tabindex="0"], .sr-collection-nav__item.js-collection-filter-nav-toggle.is-active').attr('aria-selected', 'true');
  $('.hangover-subscription-build-product-label[tabindex="1"], a.btn-with-arrow').attr('tabindex', '0');
  var ariaSelected = $('[data-selected], .hangover-subscription-build-product-label, .sr-collection-nav__item.js-collection-filter-nav-toggle');
  ariaSelected.on('click keypress', function (e) {
  if (e.type === 'click' || (e.type === 'keypress' && e.which === 13)) {
      $(this).attr('aria-selected', 'true');
      $(this).siblings().filter(ariaSelected).attr('aria-selected', 'false');
      if ($(this).is('.sr-collection-nav__item.js-collection-filter-nav-toggle')) {
        var thisText = $(this).text().trim().replace('🌴', 'i').toUpperCase();
        $('h1.sr-collection__heading').text(thisText);
        var productCount = $('.sr-collection__results-count.js-collection-filter-result-count').text();
        $('.hp-products__grid.hp-products__grid--collection span.productCount').text(productCount + ' product results displayed');
      }
    }
  });

  $('.pdp-qty-minus').attr('aria-label', 'Decrease Quantity');
  $('.pdp-qty-plus').attr('aria-label', 'Increase Quantity');
  $('.product-form__input.pdp-qty-input[readonly]').attr({ 'tabindex': '-1', 'role': 'status' });

  const element = $('.sr-collection-nav__item.js-collection-filter-nav-toggle, .hp-product-card__subttl');
  element.each(function () {
    if ($(this).is('.sr-collection-nav__item.js-collection-filter-nav-toggle') && $(this).text().includes('🌴')) {
      $(this).attr('aria-label', $(this).text().trim().replace('🌴', 'i').toUpperCase());
    }
    if ($(this).is('.hp-product-card__subttl') && $(this).text().includes('🌴')) {
      var thisText = $(this).text().trim().replace('🌴', 'i');
      var thisSiblingText = $(this).siblings('h3.hp-product-card__ttl').text().trim();
      var thisAriaLabel = thisSiblingText + ' ' + thisText;
      $(this).parent('a').attr('aria-label', thisAriaLabel.toUpperCase());
    }
  });
  $('.js-collection-filter-product a.sr-media').attr('tabindex', '-1');
  $('.sr-collection-nav__item.js-collection-filter-nav-toggle').attr({ 'role': 'button', 'tabindex': '0' }).removeAttr('href').prepend('<span class="sr-only">Shop </span>');
  $('.hp-products__grid.hp-products__grid--collection').prepend('<span class="sr-only productCount" aria-live="polite"></span>');
  $('.three-column-flex .three-column.slick-slide').removeAttr('aria-hidden tabindex');
  $('.yotpo-header-element .y-label.yotpo-user-name').attr('aria-level', '3');
  $('img.rotate, .social-proof-scroll-text-content>div, .hp-product-card__img[src*=".gif"], .hp-hero__icon-animated, .announcement-bar .js-slider').parent().addClass('has-PPBtn');
  $('<button class="playPauseButton" aria-label="Pause Animation"><svg class="play-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"></path></svg><svg class="pause-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 4h4v16H6zm8 0h4v16h-4z"></path></svg></button>').appendTo('.has-PPBtn');
  $('.has-PPBtn .playPauseButton').on('click', function (e) {
    e.preventDefault();
    $(this).parent('.has-PPBtn').toggleClass('ani-paused');
    var isPaused = $(this).parent('.has-PPBtn').hasClass('ani-paused');
    if (isPaused) {
        $(this).attr('aria-label', 'Play Animation');
    } else {
        $(this).attr('aria-label', 'Pause Animation');
    }

      // Slider handling
      let isAnnounce = $(this).parent(`.has-PPBtn`).hasClass(`announcement-bar`);
      if (isAnnounce) {
          $(`.announcement-bar .js-slider`).each(function(index, value) {
              if (isPaused) {
                  $(this).slick(`slickPause`);
              } else {
                  $(this).slick(`slickPlay`);
              }
          });
      }
  });

  $('.sfs-hero__video, .tlp-hero__video').parent().addClass('has-videoBG');
  var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  var video = isMobile ? document.getElementById('heroVideoMobile') : document.getElementById('heroVideoDesktop');
  var ppBtn = $('<button class="playPauseButton" aria-label="The video is playing now. To Pause Video, press enter."><svg class="play-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8 5v14l11-7z"></path></svg><svg class="pause-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6 4h4v16H6zm8 0h4v16h-4z"></path></svg></button>').appendTo('.has-videoBG');
  ppBtn.on('click', function() {
    if (video.paused) {
      video.play();
      ppBtn.attr('aria-label', 'The video is playing now. To Pause Video, press enter.');
      ppBtn.find('.play-icon').css('opacity', '0');
      ppBtn.find('.pause-icon').css('opacity', '1');
    } else {
      video.pause();
      ppBtn.attr('aria-label', 'The video is paused now. To Play Video, press enter.');
      ppBtn.find('.play-icon').css('opacity', '1');
      ppBtn.find('.pause-icon').css('opacity', '0');
    }
  });
  if (isMobile) {
    ppBtn.css({'left': '20px', 'opacity': '1'});
  } else {
    $('.has-videoBG').on('mouseenter focusin', function () {
      $(this).find('.playPauseButton').css('opacity', '1');
    }).on('mouseleave focusout', function () {
      $(this).find('.playPauseButton').css('opacity', '0');
    });
  }

  $('.hangover-subscription-faq').each(function () {
    var faqAccordion = $(this);
    var faqAccordionID = faqAccordion.attr('key');
    var accordionTitle = faqAccordion.find('.hangover-subscription-faq-heading');
    var accordionContent = faqAccordion.find('.hangover-subscription-faq-content');
    accordionTitle.attr({
      'tabindex': '0',
      'aria-expanded': 'false',
      'role': 'button',
      'aria-controls': 'sect_' + faqAccordionID,
      'id': 'accordion_' + faqAccordionID
    });
    accordionContent.attr({
      'role': 'region',
      'id': 'sect_' + faqAccordionID,
      'aria-labelledby': 'accordion_' + faqAccordionID
    });
    accordionTitle.on('click', function (e) {
      var isOpen = faqAccordion.hasClass('open');
      accordionTitle.attr('aria-expanded', isOpen ? 'false' : 'true');
      faqAccordion.siblings().find('.hangover-subscription-faq-heading').attr('aria-expanded', 'false');
    });
  });

  $('img[class^="hangover-subscription-build-heading-bg"]').attr('alt', 'Build Your Hangover Plan');

  $('.tlp-header__menu-btn').attr({'aria-expanded': 'false', 'aria-label': 'Navigation Menu'});
  $('.tlp-header__menu-btn').on('click', function (e) {
    var isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', isExpanded ? 'false' : 'true');
  });

  $('a.next-arrow').attr('aria-label', 'Scroll To Next Section');
  $('button.tlp-map__btn').each(function () {
    var tMB = $(this);
    var tMN = tMB.find('span.h3.tlp-map__btn-ttl').text();
    var dPID = tMB.attr('aria-controls');
    var dBID = tMB.attr('data-btn-id');
    tMB.attr({ 'aria-expanded': 'false', 'aria-label': 'Learn More Details About ' + tMN });
    tMB.on('click', function () {
      tMB.siblings('#' + dPID).css('visibility', 'visible');
      tMB.siblings('#' + dPID).find('.close-btn').focus();
      tMB.siblings('button.tlp-map__btn').attr('tabindex', '-1');
    });
    tMB.on('focusin', function () {
      $('img.tlp-map__map-hover[data-map-id=' + dBID + ']').css('opacity', '1');
      $('img.tlp-map__map-hover[data-map-id=' + dBID + ']').siblings('img.tlp-map__map-hover').css('opacity', '0');
    }).on('focusout', function () {
      $('img.tlp-map__map-hover[data-map-id=' + dBID + ']').css('opacity', '0');
      $('img.tlp-map__map-desktop').css('opacity', '1');
    });
  });
  $('.tlp-map__modal').each(function () {
    var tMM = $(this);
    var tMID = tMM.attr('id');
    var tH2 = $(this).find('h2.h3').text();
    tMM.css('visibility', 'hidden');
    tMM.find('.close-btn').attr({ 'role': 'button', 'aria-expanded': 'true', 'tabindex': '0', 'aria-label': 'Close' + tH2 + 'Details Tooltip' });
    tMM.find('.close-btn').on('click focusout', function () {
      tMM.css('visibility', 'hidden');
      tMM.siblings('button.tlp-map__btn').removeAttr('tabindex');
      setTimeout(function () {
        $('button[aria-controls=' + tMID + ']').focus();
      }, 100);
    });
  });

  $('.tlp-slider__video-modal').addClass('focus-trap');
  $('.tlp-slider__video-modal').find('.close-btn').attr({ 'aria-label': 'Close Popup', 'aria-expanded': 'true' });
  $('.js-modal-toggle').attr('aria-expanded', 'false');
  $('.tlp-slider__video-modal video.tlp-timeline__video').attr('tabindex', '-1');
  $('.js-modal-toggle').each(function () {
    var tSITID = $(this).attr('data-item-id');
    var tSVM = $('.tlp-slider__video-modal[data-modal-id=' + tSITID + ']');
    var tSVMV = tSVM.find('video.tlp-timeline__video');
    var tSVMC = tSVM.find('.close-btn');
    $(this).on('click', function () {
      tSVMC.focus();
      $(this).addClass('get-focused');
      tSVMV.attr('tabindex', '0');
      tSVM.prepend('<div class="focus-trap" id="first-focus" tabindex="0" aria-hidden="true">').append('<div class="focus-trap" id="last-focus" tabindex="0" aria-hidden="true">');
      tSVM.find('#last-focus').focus(function (e) {
        tSVM.find('#first-focus').focus();
        e.preventDefault();
      });
    });
    tSVMC.on('click', function () {
      $('.get-focused').focus();
      $('.get-focused').removeClass('get-focused');
      tSVMV.attr('tabindex', '-1');
      tSVM.find('.focus-trap').remove();
    });
  });

  $('.slick-arrow svg').attr('role', 'presentation');
  $('.yotpo-modal-dialog .yotpo-popup-box-small').removeAttr('role aria-label');
  $('.yotpo-modal-dialog .yotpo-popup-box-small ul').attr({'role': 'tablist', 'aria-label': 'testimonials tabs'});
  $('.third-part h4:empty, .hangover-subscription-intro-container-inner h4:empty').remove();
  $('.tlp-slider__slide-content .text-main').attr('tabindex', '0');
  $('.hp-hero__media a img[src*="Vita_Coco-Super_Bowl-Hangover"]').attr('alt', 'Coconut Water Product');
  $('.hp-hero__media a img[src*="MicrosoftTeams-image_21"]').attr('alt', 'Tote Bag Product');

  $('.hp-product-card').each(function () {
    var productTitle = $(this).find('.hp-product-card__ttl').text().trim();
    var productSubTitle = $(this).find('.hp-product-card__subttl').text().trim();

    $(this).find('.hp-product-card__img').attr('alt', productTitle + ' ' + productSubTitle + ' Product');
  });

  $('.hp-product-card__field').each(function (i) {
    var labelContent = $(this).find('legend').text();
    var idForSelect = $(this).find('.hp-product-card__select');
    var idFor = $(this).find('.hp-product-card__select').attr('name').trim();
    var uniqueIdFor = idFor + i
    idForSelect.attr('id', uniqueIdFor);
    $('<label for="' + uniqueIdFor + '" class="sr-only">'+ labelContent + '</label>').insertBefore(idForSelect);
  });

  $('.press-quotes-page img[src*="FoodDive"]').attr('alt', 'Food Dive');
  $('.press-quotes-page img[src*="CNBC"]').attr('alt', 'CNBC');
  $('.press-quotes-page img[src*="Parade"]').attr('alt', 'Parade');
  $('.press-quotes-page img[src*="INC"]').attr('alt', 'Inc.');

  $('<img style="margin: 0 auto; width: 80px;" src="https://cdn.shopify.com/s/files/1/0506/3573/5228/files/Accessibility_Compliance_Badge_January_2024.png?v=1704391113" alt="Access Design Studio Certified Accessble Website January 2024 Badge">').insertAfter('.footer-social');

  var impactVideo = $('#impactVideo');
  const mainVideoUrl = impactVideo.find('source').attr('src');
  $('<button class="ADBtn" aria-label="Audio Description" aria-pressed="false"> <img alt="" src="https://cdn.shopify.com/s/files/1/0506/3573/5228/files/audio-description.svg?v=1698509314"/></button>').appendTo('.impact-video__video-wrapper');
  let adEnabled = false;
  $('.ADBtn').on('click', function() {
    adEnabled = !adEnabled;
    $(this).attr({ 'aria-pressed': adEnabled, 'aria-label': adEnabled ? 'Audio Description Enabled' : 'Audio Description Disabled' });
    impactVideo.prop('muted', false);
    if (adEnabled) {
      impactVideo.attr('src', 'https://cdn.shopify.com/videos/c/o/v/8c6466e573db425e87e61a7ead9ba933.mp4');
      impactVideo.play()
    } else {
      impactVideo.attr('src', mainVideoUrl);
      impactVideo.play()
    }
  });

  faqPlusAppContentInterval = setInterval(function () {
    var faqPlusAppContent = $('.faqPlusAppFaq');
    if (faqPlusAppContent.length > 0) {
      clearInterval(faqPlusAppContentInterval);
      $('.faqPlusAppTitle').attr({ 'tabindex': '0', 'aria-expanded': 'false' });
      $('.faqPlusAppTitle').contents().wrap('<div role="heading" aria-level="3">');
      $('.faqPlusAppContent').attr('aria-hidden', 'true');
      $('.faqPlusAppContent .Hyperlink').attr('tabindex', '-1');
      $('.faqPlusAppTitle').on('click', function(e) {
        var inputId = $(this).attr('for');
        $('#' + inputId).prop('checked', function(index, checked) {
          var fPATariaExpanded = checked ? 'false' : 'true';
          var fPATariaHidden = checked ? 'true' : 'false';
          $(this).siblings('.faqPlusAppTitle').attr('aria-expanded', fPATariaExpanded);
          $(this).siblings('.faqPlusAppContent').attr('aria-hidden', fPATariaHidden);
          $(this).siblings('.faqPlusAppContent').find('.Hyperlink').attr('tabindex', checked ? '-1' : '0');
          return !checked;
        });
        e.preventDefault();
      });
    }
  },1000);

  // function tabIndexfPAT() {
  //   $('.faqPlusAppTitle').attr({ 'tabindex': '0', 'aria-expanded': 'false' });
  //   $('.faqPlusAppTitle').contents().wrap('<div role="heading" aria-level="3">');
  //   $('.faqPlusAppContent').attr('aria-hidden', 'true');
  //   $('.faqPlusAppContent .Hyperlink').attr('tabindex', '-1');
  //   $('.faqPlusAppTitle').on('keydown', function(e) {
  //     if (e.key === 'Enter' || e.keyCode === 13) {
  //       var inputId = $(this).attr('for');
  //       $('#' + inputId).prop('checked', function(index, checked) {
  //         var fPATariaExpanded = checked ? 'false' : 'true';
  //         var fPATariaHidden = checked ? 'true' : 'false';
  //         $(this).siblings('.faqPlusAppTitle').attr('aria-expanded', fPATariaExpanded);
  //         $(this).siblings('.faqPlusAppContent').attr('aria-hidden', fPATariaHidden);
  //         $(this).siblings('.faqPlusAppContent').find('.Hyperlink').attr('tabindex', checked ? '-1' : '0');
  //         return !checked;
  //       });
  //       e.preventDefault();
  //     }
  //   });
  // }


  var observer = new MutationObserver(function(mutationsList) {
    // tabIndexfPAT();
    replaceTag('h1.sg-addon-title', 'div');
    replaceTag('h1.sg-roundup-title', 'div');
    replaceTag('.address-details p.slim-title', 'h2');
    $('.sg-addon-title, .sg-roundup-title').removeAttr('tabindex');
    observer.disconnect();
  });
  var targetNode = document.querySelector('.sg-widget, .sfs-hero');
  if (targetNode) {
    observer.observe(targetNode, { childList: true, subtree: true });
  }



  console.log('A11y functions loaded...');
});
